import { Trans } from 'react-i18next';
import { Link } from 'react-router-dom';

export const Nav = () => (
  <Link to="/users"><Trans i18nKey="back" /></Link>
);

